import Vue from 'vue';

export const reportsService = {
  getReportsForUser() {
    return Vue.axios.get('/reports').then(response => response.data);
  },
  getUserGeneratedReports: function() {
    return Vue.axios.get('/reports/user-reports').then(response => response.data);
  },
  getUserReportEntitlements() {
    return Vue.axios.get('/reports/user-entitlements').then(response => response.data);
  },

  runReport: function(reportParams) {
    return Vue.axios
      .post(`/reports/run-report`, {
        ...reportParams
      })
      .then(response => response.data);
  }
};
